import { Component, OnInit } from '@angular/core';
import {MdDialogRef} from '@angular/material';
import {EntregaDialogComponent} from './entrega-dialog.component';
import { PosicionService } from '@services/posicion-service';
import * as moment from 'moment';

@Component({
  selector: 'app-entregas-ocultas-dialog',
  templateUrl: './entregas-ocultas-dialog.component.html',
  styleUrls: ['./entregas-ocultas-dialog.component.scss']
})
export class EntregasOcultasDialogComponent implements OnInit {

  public hiddenRows;
  public order;
  constructor(public dialogRef: MdDialogRef<EntregaDialogComponent>,
              private posicionService: PosicionService) { }

  ngOnInit() {
    // añadir una propiedad que controle el estado actual de la fila (mostrar o mantener oculto)
    // Formatear el string de fecha
    this.hiddenRows.forEach(item => {
      item['hidden'] = true;
      const list = item.PosString.split('-');
      item.PosString = list.length === 2 ? list[0].substring(0, 3).toUpperCase() + '-' + list[1] : item.PosString;

      // el string de Pago diferido no posee guión por lo que el length es 1. No se puede ocultar entregado ni a entregar
      item.entrega_Id = list.length === 1 ? 4 : 3;
    });
    this.sortRows();
  }

  sortRows() {
    this.hiddenRows.sort((a, b) => {
      if (a.entrega_Id === b.entrega_Id) {
        if (a.entrega_Id === 3) {
          if (a.PosString === b.PosString) {
            return a.moneda - b.moneda;
          }
          const namesA = a.PosString.split('-');
          const namesB = b.PosString.split('-');
          if (namesA.length + namesB.length === 2) {
            return this.order.indexOf(namesA[0]) - this.order.indexOf(namesB[0]);
          } else if (namesA.length !== namesB.length) {
            return namesA.length - namesB.length;
          } else {
            if (namesA[1] === namesB[1]) {
              return this.order.indexOf(namesA[0]) - this.order.indexOf(namesB[0]);
            } else {
              return Number(namesA[1]) - Number(namesB[1]);
            }
          }
        }
        if (a.entrega_Id === 4) {
          return moment(a.PosString, 'DD-MM-YYYY').valueOf() - moment(b.PosString, 'DD-MM-YYYY').valueOf();
        }
        return 0;
      } else {
        return a.entrega_Id - b.entrega_Id;
      }
    });
  }

  // si se hace clic en el ojo, mostrar o mantener oculto
  visibilityChange(item) {
    item.hidden = !item.hidden;
  }

  onSubmit() {
    // checkear si hubo cambios
    let noChanges = true;
    this.hiddenRows.forEach(item => {
      if (!item.hidden) { noChanges = false; }
    });
    // si no hubo cambios en el dialogo, cerrar sin guardar
    if (noChanges) {
      this.closeDialogNoChanges();
    } else {
      // hubo cambios en el dialogo, generar un array de objetos y enviar

      let rowsToUpdate = [];

      this.hiddenRows.forEach(x => {
        if (!x.hidden) {
          const row = {
            Id: x.Id,
            Moneda: x.Moneda,
            Fecha: x.PosFecha / 1000,
            Hidden: x.hidden
          };
          rowsToUpdate.push(row);
        }
      });

      this.posicionService.updateRows(rowsToUpdate)
        .subscribe(res => {
          if (res) {
            this.dialogRef.close(true);
          }
        });
    }
  }

  // cerrar el dialogo sin cambios
  closeDialogNoChanges() {
    this.dialogRef.close();
  }

  // cerrar el dialogo y mostrar todas las filas
  closeDialogAll() {
    this.posicionService.updateRows([])
      .subscribe(res => {
        if (res) {
          this.dialogRef.close(true);
        }
      });
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/new-precio/entregas-ocultas-dialog.component.ts